
 

 

 

 
class ConfigurationSearchCriteria 
{
    
        CategoryCode: string;
    
        Name: string;
    
}
 
export default ConfigurationSearchCriteria;
 




